import { render, staticRenderFns } from "./TopicoSalaAula.vue?vue&type=template&id=2b20e3ac&scoped=true"
import script from "./TopicoSalaAula.vue?vue&type=script&lang=js"
export * from "./TopicoSalaAula.vue?vue&type=script&lang=js"
import style0 from "./TopicoSalaAula.vue?vue&type=style&index=0&id=2b20e3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20e3ac",
  null
  
)

export default component.exports